import { createTheme } from '@mui/material/styles';
import { ExtendedButtonOptions } from 'typings/theme';
import theme from 'theme';
import { Button } from './MUiButton';

const MuiTheme = createTheme({
  typography: { fontFamily: theme.fonts.body, fontSize: 30 },
  palette: { primary: { main: theme.colors.berry60 } },
  components: {
    MuiButton: Button,
    MuiTypography: {
      defaultProps: {
        fontSize: '12px',
        fontFamily: theme.fonts.regular,
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: theme.colors.berry60,
          '&.Mui-checked': {
            color: theme.colors.berry60,
          },
          '&.MuiCheckbox-indeterminate': {
            color: theme.colors.berry60,
          },
        },
      },
    },
  } as ExtendedButtonOptions,
});

export default MuiTheme;
